var React = require('react');

function LocationIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 5.91948C11 10 5.94624 15.4444 5.94624 15.4444C5.94624 15.4444 1 10 1 5.91948C1 3.30274 3.25806 1 6.05376 1C8.84946 1 11 3.19807 11 5.91948Z","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

LocationIcon.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none"};

module.exports = LocationIcon;

LocationIcon.default = LocationIcon;
